import React from 'react'
import styles from './index.scss'
import emptyIcon from '@/libs/image/icon_empty.png'

const empty: React.FC<any> = (props) => {
  return (
    <div className={styles['dp-empty']}>
      <img className={styles['dp-empty-pic']} src={emptyIcon} />
      <p>{props?.emptyTips || '暂无数据'}</p>
    </div>
  )
}
export default empty
